/* eslint-disable no-nested-ternary */
/* eslint-disable no-case-declarations */
import React, { useEffect, useState } from "react"
import { connect, useSelector } from "react-redux"
import { roleCheck, capitalizeString } from "utils/index"
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom"
import { postComment } from "requesters/commentRequester"
import { getFlagByJobService } from "requesters/flagRequester"
import {
  ACCOUNTS_MANAGER,
  ADDITIONAL_INFO,
  ADDITIONAL_INFO_STATES,
  ADMIN,
  ADMIN_3D,
  DRAFTING_3D,
  DRAFTING_3D_MANAGER,
  DRAFTING_3D_OVERSEAS_LEBANON_MANAGER,
  DRAFTING_3D_OVERSEAS_LEBANON_USER,
  DRAFTING_3D_OVERSEAS_PHILIPPINES_MANAGER,
  DRAFTING_3D_OVERSEAS_PHILIPPINES_USER,
  DRAFTING_MANAGER,
  DRAFTING_OVERSEAS,
  DRAFTING_OVERSEAS_LEBANON,
  DRAFTING_OVERSEAS_MANAGER,
  DRAFTING_OVERSEAS_PHILIPPINES,
  DRAFTING_OVERSEAS_USER,
  DRAFTING_USER,
  DRAFTING_STATES,
  FIELD_WORK_STATES,
  PROCESSING_STATES,
  PROCESSOR,
  PROCESSOR_3D,
  VIRTUAL_DRAFTING_STATES,
  VIRTUAL_DRAFTING,
  SENT_TO_VR_DRAFTING,
  GPS_AHD,
  GPS_MGA,
  JOB_SENT,
  OPERATION_MANAGER,
  OVERSEAS,
  OVERSEAS_STATES_ALLOWED,
  OVERSEAS_USER_STATES_ALLOWED,
  ALLOWED_TO_BOOK_IN_CHECK_SURVEY_STATES,
  PENDING_PAYMENT,
  PRODUCT_CODE_PASS_THE_RESOLVE_FLAGGING_STEP,
  RECEPTION_MANAGER,
  REGISTERED_SURVEYORS_MANAGER,
  REVIEW_REPORT,
  TO_INVOICE,
  TO_LOCAL_DRAFTING,
  TO_REVIEW,
  OPERATIONS,
  ACCOUNTS,
  PRODUCT_CODE_RS_CAN_VIEW_READY_TO_SEND,
  REGISTERED_SURVEYORS,
  DRAFTING,
  PRODUCT_CODE_FULL_PAYMENT
} from "utils/constants"
// import { updateJobServiceTransition } from "requesters/jobServiceRequester"
// import CommentBox from "./activities/CommentBox"
import BookingConfirmed from "./activities/BookingConfirmed"
import DraftingRequired from "./activities/DraftingRequired"
import FieldWorkStates from "./activities/FieldWorkStates"
import PendingDeposit from "./activities/PendingDeposit"
import SendInvoice from "./activities/SendInvoice"
import CreatingDeliverables from "./activities/CreatingDeliverables"
import ToConfirm from "./activities/ToConfirm"
import SelectDraftman from "./dropdowns/SelectDraftman"
import SelectRegisteredSurveyor from "./dropdowns/SelectRegisteredSurveyor"
import SelectSurveyor from "./dropdowns/SelectSurveyor"
// import ShowChangeBookingDate from "./activities/ShowChangeBookingDate"
import { updateJobServiceTransition } from "../../../../../requesters/jobServiceRequester"
import * as reducers from "../../../reducers"
import { getBaseUrl, getCurrentRole, getCurrentUser } from "../../../reducers"
import AddNotesModal from "../modals/AddNotesModal"
import AdditionalLogModal from "../modals/AdditionalLogModal"
import AddNotesForNextSiteVisitModal from "../modals/AddNotesForNextSiteVisitModal"
import BoundaryCalculationRequired from "./activities/BoundaryCalculationRequired"
import FlaggedJobService from "./activities/FlaggedJobService"
import LinkedBookInJobs from "./activities/LinkedBookInJobs"
import ReadyToSend from "./activities/ReadyToSend"
import RegisteredSurveyor from "./activities/RegisteredSurveyor"
import ReportRequired from "./activities/ReportRequired"
import ActivityTimelines from "./activities/ActivityTimeline/ActivityTimelines"
import WaeFinal from "./activities/WaeFinal"
import AddTaskModal from "../../Activities/AddTaskModal";
import AddTimeSpent from "../../../../../components/AddTimeSpent";
import BookInCheckSurvey from "./activities/BookInCheckSurvey";
import ProcessingStage from "./activities/Processing";
import VirtualDraftingStage from "./activities/VirtualDrafting";
import Unprocessed from "./activities/Processing/Unprocessed";
import SearchesWorkflow from "./activities/SearchesWorkflow";

const Activity = ({
  activities, jobService, reloadData, setActiveTab
}) => {
  const {
    attributes: {
      state,
      invoiceState,
      accountsInvoiceState,
      accountType,
      draftmanId,
      registeredSurveyorId,
      activityLog,
      scheduledAssignments,
      jobPackUploaded,
      code,
      allCheckedOut,
      is3D,
      draftingTeam,
      cost,
      draftmanName,
      isAccountJob,
      xeroInvoiceState,
      payBeforeDrafting,
      collectPaymentOnsiteRequested,
      collectPaymentOnsiteCollected,
      collectPaymentOnsiteApproved,
      activeFlag,
      requiresRaiseInvoice,
      bookedInForJobServiceActiveFlag,
      bookedInJobServices,
      bookedInForJobServiceId,
      jobId,
      hasActiveCheckSurvey,
      hasFinalInvoice,
      hasDepositInvoice,
      additionalActivityLog,
      boundaryCalculationRequired,
      assignedSurveyorIds,
      criticalNote,
      criticalNoteCreatedBy,
      criticalNoteModifiedBy,
      criticalNoteModifiedAt,
      previousState,
      assignedDraftsmenIds,
      docketResolved,
      requiresDocketInvoice,
      paymentReminderSent,
      workflow
    }, id
  } = jobService

  const activeFlagData = activeFlag?.data?.attributes
  const activeFlagSentTo = activeFlagData?.sentTo
  const activeFlagFlagType = activeFlagData?.flagType
  const activeFlagResolved = activeFlagData?.resolved
  const notResolvedBookInJob = PRODUCT_CODE_PASS_THE_RESOLVE_FLAGGING_STEP.includes(code)
    && activeFlagFlagType === "PLAN-REQ" && !activeFlagResolved

  const isGpsAhd = (code === GPS_AHD)
  const isGpsMga = (code === GPS_MGA)

  // Roles
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const currentRole = useSelector(getCurrentRole)
  const baseUrl = useSelector(getBaseUrl)
  const isAdmin = currentRole.includes(ADMIN)
  const isOperationManager = roleCheck(systemRole, currentTeamRole, OPERATION_MANAGER) // Check direct to specific operation_manager role to prevent if there's a operation_user role later we won't mess their permission
  const isAccounts = roleCheck(systemRole, currentRole, ACCOUNTS)
  const isProcessor = roleCheck(systemRole, currentRole, PROCESSOR)
  const is3DProcessor = roleCheck(systemRole, currentRole, PROCESSOR_3D)
  const isVirtualDrafting = roleCheck(systemRole, currentRole, VIRTUAL_DRAFTING)
  const isRSManager = roleCheck(systemRole, currentTeamRole, REGISTERED_SURVEYORS_MANAGER)
  const isAdminOrOperationsOrAccounts = isOperationManager || isAccounts
  const is2DDraftingOverseasManager = roleCheck(systemRole, currentTeamRole, DRAFTING_OVERSEAS_MANAGER)
  const is3DDraftingOverseaLebanonManager = roleCheck(systemRole, currentTeamRole, DRAFTING_3D_OVERSEAS_LEBANON_MANAGER)
  const is3DDraftingOverseaPhilippinesManager = roleCheck(systemRole, currentTeamRole, DRAFTING_3D_OVERSEAS_PHILIPPINES_MANAGER)
  const isDraftingOverseasManager = is2DDraftingOverseasManager || is3DDraftingOverseaLebanonManager || is3DDraftingOverseaPhilippinesManager
  const isDraftingOverseasUser = roleCheck(systemRole, currentTeamRole, DRAFTING_OVERSEAS_USER)
    || roleCheck(systemRole, currentTeamRole, DRAFTING_3D_OVERSEAS_LEBANON_USER)
    || roleCheck(systemRole, currentTeamRole, DRAFTING_3D_OVERSEAS_PHILIPPINES_USER)

  const isOverseasTeam = isDraftingOverseasUser || isDraftingOverseasManager
  const is3DDraftingManager = roleCheck(systemRole, currentTeamRole, DRAFTING_3D_MANAGER)
  const isDraftingManager = roleCheck(systemRole, currentTeamRole, DRAFTING_MANAGER)
  const is2DDraftingUser = roleCheck(systemRole, currentTeamRole, DRAFTING_USER)
  const isLocalDraftingManager = is3DDraftingManager || isDraftingManager
  const isAllowedAddInfoDraftFlagRole = code === "ADD-INFO-DRAFT"
    && (isAdmin || isDraftingManager || is2DDraftingUser || is2DDraftingOverseasManager)
  const canBypassDraftingTeamForAddInfoDraftFlag = code === "ADD-INFO-DRAFT" && is2DDraftingOverseasManager
  const isDraftingOrDraftingAdditionalInfoState = DRAFTING_STATES.includes(state) || (state === ADDITIONAL_INFO && activeFlagSentTo === "drafting")

  // States
  const [comment, setComment] = useState("")
  const [showNotesModal, setShowNotesModal] = useState(false)
  const [showAdditionalLogModal, setAdditionalLogModal] = useState(false)
  const [showNotesForNextSiteVisitModal, setShowNotesForNextSiteVisitModal] = useState(false)
  const [showAddTaskModal, setShowAddTaskModal] = useState(false)
  const [finalPaymentReminderSentClicked, setFinalPaymentReminderSentClicked] = useState(false)
  const [activityLogFiltered, setActivityLogFiltered] = useState(activityLog)
  const [currentUserAssigned, setCurrentUserAssigned] = useState(null)

  // Vars
  const isAdditionalDraftman = assignedDraftsmenIds.includes(Number(currentUser.id))
  const isPrimaryDraftman = Number(currentUser.id) === draftmanId || isAdmin
  const isFiftyFiftyAccount = accountType === "50% - 50%"

  const canAddNoteForNextSiteVisit = isOperationManager || roleCheck(systemRole, currentRole, REGISTERED_SURVEYORS) || roleCheck(systemRole, currentRole, DRAFTING)
  const canDoFinalWaeFlow = isOperationManager || isRSManager

  // Func
  const draftingTeamAllowed = () => {
    if (systemRole === ADMIN) return true;

    const jobServiceDraftingTeam = draftingTeam
    const isAssignedDraftsman = isPrimaryDraftman || isAdditionalDraftman
    const hasManagerRole = is3DDraftingManager || isDraftingManager
    const canAccess = hasManagerRole || isAssignedDraftsman
    const isLocalOverseasAssignableState = ["drafting_assignment_required", TO_LOCAL_DRAFTING].includes(state)

    if (!jobServiceDraftingTeam && isLocalOverseasAssignableState && hasManagerRole) return true
    if (!jobServiceDraftingTeam) return canAccess;

    const jobDraftingSituationPermissions = {
      [DRAFTING_OVERSEAS_LEBANON]: is3D && (is3DDraftingOverseaLebanonManager || canAccess),
      [DRAFTING_OVERSEAS_PHILIPPINES]: is3D && (is3DDraftingOverseaPhilippinesManager || canAccess),
      [DRAFTING_OVERSEAS]: !is3D && (is2DDraftingOverseasManager || canAccess)
    };

    return jobDraftingSituationPermissions[jobServiceDraftingTeam] || false;
  }

  const accountJobsCheck = () => isAccountJob && xeroInvoiceState === "authorised" && state === "to_invoice"

  const jobPackWarningRender = () => {
    if (isGpsAhd || isGpsMga) return false;

    if (!jobPackUploaded) {
      if (!isFiftyFiftyAccount) return true;

      return payBeforeDrafting || ["paid_deposit", "paid_full"].includes(invoiceState) || Number(cost) === 0
    }

    return false
  }

  const renderToInvoiceLabel = invoiceState => {
    if (invoiceState === "deposit_invoice_drafted") {
      return "Awaiting payment (Deposit)"
    }
    if (invoiceState === "final_invoice_drafted" && !hasDepositInvoice && isFiftyFiftyAccount && !PRODUCT_CODE_FULL_PAYMENT.includes(code)) {
      return "Awaiting payment (Deposit)"
    }
    if (invoiceState === "paid_deposit" && hasFinalInvoice) {
      return "Awaiting payment (Final)"
    }
    if (invoiceState === "final_invoice_drafted") {
      return "Awaiting payment (Final)"
    }
    return "To Invoice"
  }

  const showSendPaymentReminder = () => {
    if (paymentReminderSent) return false
    if (renderToInvoiceLabel(invoiceState) === "Awaiting payment (Deposit)") return false
    if (!["to_invoice", "awaiting_payment"].includes(state)) return false
    if ((invoiceState === "paid_deposit" && hasFinalInvoice) || invoiceState === "final_invoice_drafted") return true
    return false
  }

  const markAsFinalInvoicePaymentReminderSentHandler = () => {
    setFinalPaymentReminderSentClicked(true)
    updateJobServiceTransition(baseUrl, id, "mark-as-final-invoice-payment-reminder-sent")
      .then(res => {
        if (res.status === 200) {
          reloadData()
        } else {
          setFinalPaymentReminderSentClicked(false)
          toast.error(
            <div>
              <span role="img" aria-label="failure-icon">❌</span>
              <span className="ml-2">{res?.error?.response?.data?.errors[0]?.detail}</span>
            </div>,
            {
              toastId: "container-inner",
              containerId: "main"
            }
          )
        }
      })
      .catch(() => {
        setFinalPaymentReminderSentClicked(false)
      })
  }

  const getCurrentUserAssignmentRole = () => {
    scheduledAssignments.map(scheduledAssignment => {
      setCurrentUserAssigned(scheduledAssignment.assignments.find(a => a.surveyorId === Number(currentUser.id)))
    })
  }

  useEffect(() => {
    getCurrentUserAssignmentRole()
  }, [id])

  useEffect(() => {
    if (!isAdminOrOperationsOrAccounts) {
      const filteredActivityLog = activityLog.filter(activity => {
        const { data: { label } } = activity
        return !["Disabled Unmatched Invoice warning", "Enabled Unmatched Invoice warning", "Disabled Outstanding Invoice warning", "Enabled Outstanding Invoice warning"].includes(label)
      })
      setActivityLogFiltered(filteredActivityLog)
    } else {
      setActivityLogFiltered(activityLog)
    }
  }, [activityLog])

  const raiseInvoiceRole = () => {
    if (roleCheck(systemRole, currentTeamRole, ACCOUNTS_MANAGER)) {
      return (<SendInvoice jobService={jobService} reloadData={reloadData} setActiveTab={setActiveTab} />)
    }
    return null
  }

  const pendingDepositRoles = () => {
    if (roleCheck(systemRole, currentTeamRole, ACCOUNTS_MANAGER) || isOperationManager) {
      return (
        <React.Fragment>
          { showSendPaymentReminder() ? (
            <>
              <p className="mb-3 mt-3 bg-coral py-2 px-3 rounded">
                Send the final payment reminder
                {" "}
                and click &apos;
                Mark as Sent
                &apos; after sending.
              </p>
              <button type="submit" className="btn btn-outlined-blue btn-md mr-2" disabled={finalPaymentReminderSentClicked} onClick={markAsFinalInvoicePaymentReminderSentHandler}>
                Mark as Sent
                {finalPaymentReminderSentClicked && <Spinner className="ml-1" animation="border" role="status" size="sm" />}
              </button>
            </>
          ) : (
            <PendingDeposit
              currentTeamRole={currentTeamRole}
              roleCheck={roleCheck}
              systemRole={systemRole}
              jobService={jobService}
              reloadData={reloadData} />
          )}
        </React.Fragment>
      )
    }
    return null
  }

  const confirmCollectedFromSurveyor = () => {
    updateJobServiceTransition(baseUrl, id, "collect-payment-onsite-approve")
    .then(res => {
      if (res.status === 200) {
        reloadData()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }

  const flaggedJobRoles = () => {
    const sentTo = activeFlag?.data?.attributes?.sentTo
    switch (sentTo) {
      case "drafting":
        const isManagerGuy = is3D ? is3DDraftingManager : isDraftingManager
        const canDoFlagWork = isManagerGuy || isPrimaryDraftman
        return canDoFlagWork;
      case SENT_TO_VR_DRAFTING:
        return isVirtualDrafting;
      case "processing":
        return is3D ? is3DProcessor : isProcessor;
      case "operations":
        return isOperationManager;
      case "registered_surveyors":
        return isRSManager || Number(currentUser.id) === registeredSurveyorId;
      default:
        return false;
    }
  }

  const renderInvoiceState = invoiceState => {
    if (invoiceState === "deposit_invoice_drafted") {
      if (jobService.attributes.payBeforeDrafting) {
        return "Awaiting payment (Deposit) - Payment Required Prior to Drafting"
      }
      return "Awaiting payment (Deposit)"
    }
    if (invoiceState === "final_invoice_drafted" && !hasDepositInvoice && isFiftyFiftyAccount && !PRODUCT_CODE_FULL_PAYMENT.includes(code)) {
      if (jobService.attributes.payBeforeDrafting) {
        return "Final Invoice Drafted - Awaiting payment (Deposit) - Payment Required Prior to Drafting"
      }
      return "Final Invoice Drafted - Awaiting payment (Deposit)"
    }
    if (hasDepositInvoice && invoiceState === "paid_deposit" && !hasFinalInvoice) {
      return "Paid Deposit - Final Invoice Pending"
    }
    if ((invoiceState === "paid_deposit")) {
      return "Paid Deposit - Awaiting payment (Final)"
    }
    if (invoiceState === "final_invoice_drafted") {
      return "Awaiting payment (Final)"
    }
    return capitalizeString(invoiceState)
  }

  const collectedAmounts = scheduledAssignments
  .flatMap(assignment => assignment.assignments)
  .map(i => i.collectPaymentOnsiteCollectedAmount)

  const hasZeroCollectedPayment = collectedAmounts.includes("0.0")

  return (
    <div id="pills-job-activities" className="tab-pane fade show active" role="tabpanel">
      <div className="activity-tab-toolbar">
        <div className="activity-tab-toolbar__group activity-tab-toolbar__group--notes">
          <button className="btn btn-outline-primary" type="button" onClick={() => setShowNotesModal(true)}>Add Note</button>
          <AddNotesModal
            show={showNotesModal}
            reloadData={reloadData}
            jobService={jobService}
            onHide={() => { setShowNotesModal(false) }} />

          { canAddNoteForNextSiteVisit && (
            <>
              <button className="btn btn-outline-primary" type="button" onClick={() => setShowNotesForNextSiteVisitModal(true)}>Note for Next Site Visit</button>
              <AddNotesForNextSiteVisitModal
                show={showNotesForNextSiteVisitModal}
                reloadData={reloadData}
                jobService={jobService}
                onHide={() => { setShowNotesForNextSiteVisitModal(false) }} />
            </>
          )}

          { isAdmin && (
            <>
              <button className="btn btn-secondary" type="button" onClick={() => setAdditionalLogModal(true)}>Additional Log</button>
              <AdditionalLogModal
                show={showAdditionalLogModal}
                onHide={() => { setAdditionalLogModal(false) }}
                additionalLog={additionalActivityLog} />
            </>
          )}

          { isRSManager && (
            <div className="add-rs-activity">
              <button
                type="button"
                className="btn btn-outline-primary btn-md"
                onClick={() => setShowAddTaskModal(true)}>
                + Add Activity
              </button>
              <AddTaskModal
                modalTitle="Add Activity"
                show={showAddTaskModal}
                onHide={() => setShowAddTaskModal(false)}
                jobService={jobService}
                onCreated={createdTask => {
                  window.location.href = `/registered-surveyors-activities/${createdTask?.id}`
                }}
                reloadData={() => {}} />
            </div>
          )}
        </div>
        <div className="activity-tab-toolbar__group activity-tab-toolbar__group--actions">
          <AddTimeSpent
            buttonText="+ Add Time"
            reloadData={reloadData}
            trackableId={jobService.id}
            trackableType={jobService.type}
            trackedOnState={state} />

          { ALLOWED_TO_BOOK_IN_CHECK_SURVEY_STATES.includes(state) && isOperationManager && !hasActiveCheckSurvey && (
            <BookInCheckSurvey
              jobService={jobService}
              reloadData={reloadData} />
          )}
        </div>
      </div>

      <ul className="list-unstyled activities-list border-left">

        { canDoFinalWaeFlow && JOB_SENT === state && (
          <WaeFinal jobService={jobService} reloadData={reloadData} />
        )}

        {((state === "ready_to_send" || accountJobsCheck()) && (isOperationManager || roleCheck(systemRole, currentTeamRole, RECEPTION_MANAGER) || (isRSManager && PRODUCT_CODE_RS_CAN_VIEW_READY_TO_SEND.includes(code)))) && (
          <ReadyToSend
            jobService={jobService}
            reloadData={reloadData} />
        )}

        { FIELD_WORK_STATES.includes(state) && (
          <>
            <FieldWorkStates
              jobService={jobService}
              reloadData={reloadData}
              setActiveTab={setActiveTab} />
          </>
        )}

        {
          state === "create_deliverables" && (
            <li className="activity timeline-activity" key="CreatingDeliverables">
              <div className="circle circle-outline" />
              <strong>Creating Deliverables</strong>
              <CreatingDeliverables jobService={jobService} reloadData={reloadData} />
            </li>
          )
        }

        { PROCESSING_STATES.includes(state) && (isProcessor || is3DProcessor) && (
          <ProcessingStage jobService={jobService} reloadData={reloadData} />
        )}

        { (state === ADDITIONAL_INFO && activeFlagSentTo === "processing") && (isProcessor || is3DProcessor) && (
          <li className="activity timeline-activity" key="flagged-to-processing-stage-unprocessed-view">
            <div className="circle circle-outline" />
            <div className="mb-3">
              <strong>Unprocessed</strong>
            </div>

            <Unprocessed
              forAdditionalWork
              jobService={jobService}
              comment={comment}
              setComment={setComment}
              reloadData={reloadData} />
          </li>
        )}

        { (VIRTUAL_DRAFTING_STATES.includes(state) || (state === ADDITIONAL_INFO && activeFlagSentTo === SENT_TO_VR_DRAFTING)) && isVirtualDrafting && (
          <VirtualDraftingStage
            forAdditionalWork={state === ADDITIONAL_INFO}
            jobService={jobService}
            reloadData={reloadData} />
        )}

        {(isDraftingOrDraftingAdditionalInfoState && (isLocalDraftingManager || isPrimaryDraftman || isAdditionalDraftman || isAllowedAddInfoDraftFlagRole) && !(isOverseasTeam && !isAdmin) && (draftingTeamAllowed() || isAllowedAddInfoDraftFlagRole)) && (
          <li className="activity timeline-activity" key="DraftingRequired">
            <div className="circle circle-outline" />
            <div className="d-flex justify-content-between">
              <div className={`activity-status ${!isDraftingManager ? "mb-3" : null}`}>
                <strong>Drafting Required</strong>
                {draftmanName && (
                  <strong className="ml-2">{`(${draftmanName})`}</strong>
                )}
              </div>
              <SelectDraftman jobService={jobService} reloadData={reloadData} readOnly={!(isAdmin || (isLocalDraftingManager && !OVERSEAS_STATES_ALLOWED.includes(state)) || currentRole?.includes(ADMIN_3D))} />
            </div>

            <DraftingRequired
              jobService={jobService}
              reloadData={reloadData}
              noActions={state === "additional_info" || (isAdditionalDraftman && !isLocalDraftingManager)}
              isPrimaryDraftman={isPrimaryDraftman}
              systemRole={systemRole}
              currentTeamRole={currentTeamRole}
              comment={comment}
              setComment={setComment} />
          </li>
        )}

        {((isOverseasTeam && !isAdmin) && (draftingTeamAllowed() || canBypassDraftingTeamForAddInfoDraftFlag)) && (
          <li className="activity timeline-activity" key="DraftingRequiredOverseas">
            {OVERSEAS_STATES_ALLOWED.includes(state) && (
              <>
                <div className="circle circle-outline" />
                <div className="d-flex justify-content-between">
                  <div className={`activity-status ${!isDraftingOverseasManager ? "mb-3" : null}`}>
                    <strong>Drafting Required</strong>
                    {draftmanName && (
                      <strong className="ml-2">{`(${draftmanName})`}</strong>
                    )}
                  </div>
                  <SelectDraftman jobService={jobService} reloadData={reloadData} readOnly={!isDraftingOverseasManager} />
                </div>
              </>
            )}
            {((isDraftingOverseasUser && state === OVERSEAS_USER_STATES_ALLOWED) || (isDraftingOverseasManager && OVERSEAS_STATES_ALLOWED.includes(state)) || (isDraftingOverseasManager && code === "ADD-INFO-DRAFT" && isDraftingOrDraftingAdditionalInfoState)) && (
              <DraftingRequired
                jobService={jobService}
                reloadData={reloadData}
                isPrimaryDraftman={isPrimaryDraftman}
                systemRole={systemRole}
                currentTeamRole={currentTeamRole}
                comment={comment}
                overseas
                noActions={(isAdditionalDraftman && !isDraftingOverseasManager) || (canBypassDraftingTeamForAddInfoDraftFlag && !draftingTeamAllowed())}
                setComment={setComment} />
            )}
          </li>
        )}

        {
          (state === TO_REVIEW && (isRSManager || Number(currentUser.id) === registeredSurveyorId)) && (
            <li className="activity timeline-activity" key="RegisteredSurveyor">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className={`activity-status ${!isRSManager ? "mb-3" : null}`}>
                  <strong>Registered Surveyor</strong>
                </div>
                {roleCheck(systemRole, currentTeamRole, "registered_surveyors_manager") && (
                  <SelectRegisteredSurveyor jobService={jobService} reloadData={reloadData} />
                )}
              </div>
              {!boundaryCalculationRequired && (
                <RegisteredSurveyor
                  notResolvedBookInJob={notResolvedBookInJob}
                  jobService={jobService}
                  reloadData={reloadData}
                  systemRole={systemRole}
                  currentTeamRole={currentTeamRole}
                  currentUser={currentUser}
                  comment={comment}
                  setComment={setComment} />
              )}

            </li>
          )
        }

        {
          (state === REVIEW_REPORT && (isRSManager || isDraftingManager)) && (
            <li className="activity timeline-activity" key="Report Required">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className={`activity-status ${!isRSManager ? "mb-5" : null}`}>
                  <strong>Report Required</strong>
                </div>
                {/* <SelectRegisteredSurveyor jobService={jobService} reloadData={reloadData} /> */}
              </div>
              <ReportRequired
                jobService={jobService}
                reloadData={reloadData}
                activityID={id}
                comment={comment}
                setComment={setComment} />
            </li>
          )
        }

        { isOperationManager && workflow === "8" && state === "confirmed" && (
          !isFiftyFiftyAccount || invoiceState === "paid_full" || Number(cost) === 0
        ) && (
          <li className="activity timeline-activity" key="Searches workflow (8)">
            <div className="circle circle-yellow" />
            <div className="justify-content-between">
              <div className="activity-status">
                <strong>Searches Workflow</strong>
              </div>
            </div>
            <SearchesWorkflow
              jobService={jobService}
              reloadData={reloadData}
              systemRole={systemRole}
              currentTeamRole={currentTeamRole}
              comment={comment}
              setComment={setComment} />
          </li>
        )}

        { isAdminOrOperationsOrAccounts && collectPaymentOnsiteRequested && collectPaymentOnsiteCollected && !collectPaymentOnsiteApproved && !hasZeroCollectedPayment && (
          <li className="activity timeline-activity" key="Approve Collect Payment Onsite">
            <div className="circle circle-yellow" />
            <div className="justify-content-between">
              <div className="activity-status">
                <strong>Collect Payment Onsite</strong>
                <div className="grey-sub-activities mt-3">
                  <button type="button" className="btn btn-outlined-blue btn-md mr-2 mb-1" onClick={confirmCollectedFromSurveyor}>
                    Collected from Surveyor
                  </button>
                </div>
              </div>
            </div>
          </li>
        )}

        { /* Have to recheck here with the same component above as it starts to become complicated logically */}
        {
          (
            (Number(cost) !== 0 || !docketResolved)
            && !["rescheduled", "cancelled"].includes(state)
            && (
              state === "to_invoice"
              || (isFiftyFiftyAccount && invoiceState === "paid_deposit" && state === "to_confirm" && hasFinalInvoice)
              || (isFiftyFiftyAccount && ["invoice_pending", "deposit_invoice_drafted"].includes(invoiceState))
              || (isFiftyFiftyAccount && invoiceState === "final_invoice_drafted" && hasFinalInvoice && !hasDepositInvoice)
              || state === "awaiting_payment"
            )
          ) && (
            <li className="activity timeline-activity" key="To invoice">
              <>
                <div className="circle circle-yellow" />
                <div className="justify-content-between">
                  <div className="activity-status">
                    <strong>{renderToInvoiceLabel(invoiceState)}</strong>
                    <div className="grey-sub-activities">
                      <div className="my-3">
                        {requiresDocketInvoice && invoiceState === "paid_full" ? "Requires Docket Invoice" : invoiceState === "paid_full" && !docketResolved ? "Docket Invoiced" : renderInvoiceState(invoiceState)}
                      </div>
                      {(invoiceState === "paid_full" && requiresDocketInvoice) || !(["deposit_invoice_drafted", "final_invoice_drafted", "paid_full"].includes(invoiceState) || (invoiceState === "paid_deposit" && hasFinalInvoice) || state === "awaiting_payment") ? (raiseInvoiceRole()) : (pendingDepositRoles())}
                    </div>
                  </div>
                </div>  
              </>
            </li>
          )
        }

        {
          criticalNote && (
            <li className="activity timeline-activity" key="Critical Note For Client">
              <div className="circle circle-red" />
              <div className="d-flex justify-content-between">
                <div className="activity-status">
                  <strong>{`Critical Note For Client - by ${criticalNoteCreatedBy}`}</strong>
                  <br></br>
                  <span className="activities-timestamp">{`${criticalNoteModifiedAt} - Last modified by ${criticalNoteModifiedBy}`}</span>
                </div>
              </div>
              <div className="timeline-item mt-2">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-3">
                    <div dangerouslySetInnerHTML={{ __html: criticalNote || "" }}></div>
                  </div>
                </div>
              </div>
            </li>
          )
        }

        {
          requiresRaiseInvoice && (
            <li className="activity timeline-activity" key="To invoice">
              <>
                <div className="circle circle-yellow" />
                <div className="justify-content-between">
                  <div className="activity-status">
                    <strong>To Invoice</strong>
                    <div className="grey-sub-activities">
                      <div className="my-3">
                        {renderInvoiceState(invoiceState)}
                      </div>
                      {raiseInvoiceRole()}
                    </div>
                  </div>
                </div>
              </>
            </li>
          )
        }

        {
          ((ADDITIONAL_INFO_STATES.includes(state) || (state === TO_REVIEW && boundaryCalculationRequired)) && activeFlag?.data && flaggedJobRoles()) && (
            <li className="activity timeline-activity" key="Flagged Job">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className="activity-status">
                  <strong>Flagged Job</strong>
                </div>
              </div>
              <FlaggedJobService
                jobService={jobService}
                reloadData={reloadData}
                comment={comment}
                setComment={setComment} />
            </li>
          )
        }

        {
          (bookedInForJobServiceActiveFlag?.data) && (
            <li className="activity timeline-activity" key="Flagged Job">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className="activity-status">
                  <strong>Flagged Job</strong>
                </div>
              </div>
              <FlaggedJobService
                previewOnly
                flag={bookedInForJobServiceActiveFlag}
                jobService={jobService}
                reloadData={reloadData} />
            </li>
          )
        }

        {
          bookedInJobServices?.length > 0 && (
            <li className="activity timeline-activity" key="Linked Book in Jobs">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className="activity-status">
                  <strong>Linked Book In Jobs</strong>
                </div>
              </div>
              <LinkedBookInJobs bookedInJobServices={bookedInJobServices} />
            </li>
          )
        }

        {
          bookedInForJobServiceId && (
            <li className="activity timeline-activity" key="Linked Book in Jobs">
              <div className="circle circle-outline" />
              <div className="d-flex justify-content-between">
                <div className="activity-status">
                  <strong>Linked Book In Jobs</strong>
                </div>
              </div>
              <div className="timeline-item mt-2">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-3">
                    <div className="row align-items-center">
                      <div className="col-sm-6">
                      </div>
                    </div>
                    <a
                      href={`/jobs/${jobId}/job_services/${bookedInForJobServiceId}`}
                      className="d-block text-dark">
                      Linked Parent Job
                    </a>
                  </div>
                </div>
              </div>
            </li>
          )
        }

        {
          boundaryCalculationRequired && state === "field_work_incompleted" && previousState !== TO_REVIEW 
          && (isOperationManager || assignedSurveyorIds.includes(Number(currentUser.id)))
          && workflow !== "8"
          && (
            <>
              <div className="d-flex justify-content-between">
                <li className="activity timeline-activity datepicker-container mb-0" key="BookingConfirmed">
                  <div className="circle circle-outline" />
                  <div className="d-flex justify-content-between">
                    <div className="activity-status">
                      <strong>Boundary Calculation Required</strong>
                    </div>
                  </div>
                </li>
              </div>
              <li className="activity timeline-activity" key={`row-${2}`}>
                {jobPackWarningRender() && (
                  <p className="mb-0 mt-3 bg-coral py-2 px-3 rounded">Job Pack files missing</p>
                )}
                {currentUserAssigned?.role === "assistant" && (
                  <p className="mb-0 mt-3 bg-secondary py-2 px-3 rounded text-white">Job assistant</p>
                )}

                {scheduledAssignments.map((scheduledAssignment, index) => {
                  const assigned = scheduledAssignment.assignments.find(a => a.surveyorId === Number(currentUser.id))
                  return (
                    <>
                      {(isOperationManager || assigned) && (
                        <div className="timeline-item mb-3" key={scheduledAssignment?.scheduledAt}>
                          <BookingConfirmed
                            showActionButtons={false}
                            showRequestGps={index === 0}
                            assignmentPosition={index}
                            jobService={jobService}
                            scheduledAssignment={scheduledAssignment}
                            reloadData={reloadData}
                            currentUser={currentUser}
                            systemRole={systemRole}
                            currentTeamRole={currentTeamRole}
                            activityID={id}
                            comment={comment}
                            setComment={setComment}
                            setActiveTab={setActiveTab} />
                        </div>
                      )
                      }
                      <BoundaryCalculationRequired currentUser={currentUser} jobService={jobService} isAdmin={isAdmin} scheduledAssignment={scheduledAssignment} />
                    </>
                  )
                })}
              </li>
            </>
          )
        }

        {
          <ActivityTimelines activityLog={activityLogFiltered} jobService={jobService} reloadData={reloadData} />
        }
      </ul>
    </div>
  )
}

const mapStateToProps = state => ({
  currentRole: reducers.getCurrentRole(state)
})

export default withRouter(connect(mapStateToProps, {})(Activity))
